import { ChakraProvider } from "@chakra-ui/react";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const container = document.getElementById("root");

if (container != null) {
  const root = createRoot(container);

  root.render(
    <ChakraProvider>
      <App />
    </ChakraProvider>,
  );
}
